import { useMemo } from 'react';

import { Box, Divider, Typography } from '@mui/material';
import { useField } from 'formik';
import { useRecoilValue } from 'recoil';

import { transactionOfferAtom } from 'src/atoms';
import {
    COMMERCIAL_CARDS,
    OTHER_CARDS,
    PERSONAL_CARDS,
} from 'src/pages/AddTransactionPricingPage/sections/TransactionPricing';

import { CustomGridInput } from './components';
import { GridHeader } from './GridHeader';

import { CardOption } from '.';

interface CardChargeProps {
    editable: boolean;
    name: string;
    heading: string;
}

export const CardCharge: React.FC<CardChargeProps> = ({ editable, name, heading }) => {
    const [{ value: cards }] = useField(name);
    const selectedTransactionOffer = useRecoilValue(transactionOfferAtom);
    const cardOptions: CardOption[] = useMemo(() => {
        const combinedCardOptions = [...PERSONAL_CARDS, ...COMMERCIAL_CARDS, ...OTHER_CARDS];
        if (selectedTransactionOffer) {
            return (selectedTransactionOffer?.transactionPricingCards ?? []).map((cardCharge) => {
                const cardDefault = combinedCardOptions.find((el) => el.name === cardCharge.name);
                return {
                    ...cardCharge,
                    label: cardDefault?.heading,
                    isConstant: cardDefault?.isConstant || false,
                };
            });
        }
        return [];
    }, [selectedTransactionOffer]);

    return (
        <Box>
            <Typography fontSize="24px" color="#434341" marginBottom="8px">
                {heading}
            </Typography>
            <Divider
                sx={{
                    borderColor: 'warning.main',
                    marginBottom: '34px',
                }}
            />
            <GridHeader />

            {Object.keys(cards).map((key) => (
                <CustomGridInput
                    key={key}
                    name={`${name}.${key}`}
                    card={cardOptions.find((el) => el.name === key)}
                    editable={editable}
                    componentType="card-charges"
                />
            ))}
        </Box>
    );
};

// masterCardSigniaOrMastercardWorld
